import { render, staticRenderFns } from "./MobileList.vue?vue&type=template&id=4e8853e3&scoped=true"
import script from "./MobileList.vue?vue&type=script&lang=js"
export * from "./MobileList.vue?vue&type=script&lang=js"
import style0 from "./MobileList.vue?vue&type=style&index=0&id=4e8853e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_r4vjonmvno2vgxt4mkj3onxa2i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8853e3",
  null
  
)

export default component.exports